import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { compose } from 'recompose';
import { ApolloProvider } from 'react-apollo';
import { passApplication } from '@unitedtraders/application-bootstrapper';
import configureStore from '../store';
import { initApolloClient } from '../services/apolloClient';
import { initApi } from '../services/api';
import { ApiContext } from '../hooks/useApi';

const enhance = compose(passApplication);

class ReduxApp extends Component {
  componentWillMount() {
    const { application } = this.props;

    this.apolloClient = initApolloClient(application);

    this.api = initApi(application.settings.get('grpcGateway').url);

    const { store, runApp } = configureStore({
      app: application,
      config: application.settings.settings,
      apolloClient: this.apolloClient,
      api: this.api
    });

    runApp();

    this.store = store;
  }

  render() {
    return (
      <ApolloProvider client={this.apolloClient}>
        <ApiContext.Provider value={this.api}>
          <Provider store={this.store}>
            <div>{this.props.children}</div>
          </Provider>
        </ApiContext.Provider>
      </ApolloProvider>
    );
  }
}

export default enhance(ReduxApp);



// WEBPACK FOOTER //
// ./src/components/ReduxApp.jsx